import {I18n} from "i18n-js";
import {LanguagesType} from "../types/Languages";
import translations from './translations.json';

export enum LanguagesIds {
    'lv' = 1,
    'en' = 2,
    'ru' = 4,
}

export const mappedLanguagesById = {
    [LanguagesType.Latvian]: 1,
    [LanguagesType.English]: 2,
    [LanguagesType.Russian]: 4,
}

const getTranslations = () => {
    let mappedTranslations = {
        [LanguagesType.Latvian]: [],
        [LanguagesType.English]: [],
        [LanguagesType.Russian]: [],
    };

    translations
        .forEach((value) => {
            const lang = (Object.keys(mappedLanguagesById) as (keyof typeof mappedLanguagesById)[]).find((key) => {
                return mappedLanguagesById[key] === value.LanguageId;
            });
            // @ts-ignore
            mappedTranslations[lang][value.TranslationId] = value.Translation;
        });

    return mappedTranslations;
}

const i18n = new I18n(getTranslations());

i18n.defaultLocale = LanguagesType.English;
i18n.enableFallback = true;

i18n.interpolate = (i18n, message, options) => {
    if (typeof options['<p1>'] !== "undefined") {
        return message.replace('<p1>', options['<p1>']);
    }

    return message;
};

export default i18n;